import { useContext } from 'react'
import { Button } from '../Styles'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { AuthContext } from "../../contexts/Auth"
import { modalOrganizacaoUsuarioResposta } from '../../interfaces/auth'
import { AuthGoogle } from '../../helpers/auth'
import { recuperarSenha } from '../../services/auth'
import './modalorganizacoes.css'

function ModalOrganizacoesUsuario (organizacaoUsuario: modalOrganizacaoUsuarioResposta) {

    const { modalExibir } = useContext(ModalEstadoContext)
    const { isAuth } = useContext(AuthContext)

    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = location

    const [tokens, email] = location.hash.substring(1).split('#')
    const [emailUsuario] = location.hash.substring(1).split('#')

    const ocultarModal = () => {
        modalExibir('')
        return navigate('/')
    }

    const selecionarOrganizacao = async (idOrganizacao: string) => {

        if(tokens && email) {

            modalExibir('')

            return AuthGoogle({
                idOrganizacao,
                tokens,
                email,
                isAuth,
                navigate
            })
        }

        if(emailUsuario) {

            const payload = {
                email: emailUsuario,
                idOrganizacao
            }

            await recuperarSenha (payload)
        }

        navigate(`${pathname}?o-s=${idOrganizacao}`)

        return modalExibir('')
    }


    return (

        <div className='modalUsuarioOrganizacao'>
            <section className = 'modalUsuarioOrganizacaoContainer'>
                <span className='modalUsuarioOrganizacaoContent'>
                    {organizacaoUsuario.dados.map((dado) => (
                        <div key={Math.random()} onClick={() => selecionarOrganizacao(dado.idOrganizacao)}>
                            <img src={dado.organizaco.avatar} alt=''/>
                            <p>{dado.organizaco.nomeFantasia}</p>
                        </div>
                    ))}
                </span>
                <Button type='button' cor='cancelar' isLoading={false} onClick={ocultarModal}>Cancelar Operação</Button>
            </section>
        </div>
    )
}

export default ModalOrganizacoesUsuario